"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ErrorSummary;
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.map.js");
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ErrorSummary(props) {
  var _errorInformation$any;
  var errorInformation = props.errorInformation;
  var summaryRef = (0, _react.useRef)(null);
  var touched = (0, _react.useRef)((_errorInformation$any = errorInformation.anyTouched) !== null && _errorInformation$any !== void 0 ? _errorInformation$any : false);
  var firstLinkRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!touched.current && errorInformation.anyTouched) {
      touched.current = true;
      if (summaryRef && summaryRef.current.scrollIntoView) {
        summaryRef.current.scrollIntoView();
      }
      if (errorInformation.anyTouched && firstLinkRef && firstLinkRef !== null && firstLinkRef !== void 0 && firstLinkRef.current) {
        var _firstLinkRef$current, _firstLinkRef$current2, _firstLinkRef$current3;
        firstLinkRef === null || firstLinkRef === void 0 ? void 0 : (_firstLinkRef$current = firstLinkRef.current) === null || _firstLinkRef$current === void 0 ? void 0 : (_firstLinkRef$current2 = _firstLinkRef$current.children) === null || _firstLinkRef$current2 === void 0 ? void 0 : (_firstLinkRef$current3 = _firstLinkRef$current2[0]) === null || _firstLinkRef$current3 === void 0 ? void 0 : _firstLinkRef$current3.focus();
      }
    }
  }, [errorInformation]);
  var errors = (0, _react.useMemo)(function () {
    var errorArr = [];
    if (errorInformation !== null && errorInformation !== void 0 && errorInformation.syncErrors) {
      Object.keys(errorInformation.syncErrors).forEach(function (key) {
        errorArr.push({
          key: key,
          message: errorInformation.syncErrors[key]
        });
      });
    }
    return errorArr;
  }, [errorInformation]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: summaryRef,
    role: "alert"
  }, props !== null && props !== void 0 && props.errorInformation.anyTouched && errors !== null && errors !== void 0 && errors.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-summary--container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "error-summary--title"
  }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, props === null || props === void 0 ? void 0 : props.label)), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "error-summary--item-container"
  }, errors === null || errors === void 0 ? void 0 : errors.map(function (err, idx) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "".concat(err.key, "_error-message"),
      ref: idx === 0 && firstLinkRef ? firstLinkRef : undefined,
      className: "error-summary--item"
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "#t-".concat(err.key, "_error-message_"),
      className: "error-summary--item-link"
    }, err.message));
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null));
}